import React from "react"
import { connect } from "react-redux"
import withStyles from '@mui/styles/withStyles';

import InputGroup from "../InputGroup/InputGroup"
import colors from "../../Constants/colors"

import "./ProfileProfessionalOne.css"

const styleSheet = () => ({
  label: {
    fontFamily: "Lato-Regular",
    color: colors.midnight
  }
})

const inputs = [
  {
    id: 0,
    className: "currentJob",
    inputType: "text",
    userField: "community.current_job",
    placeHolder: "Current Job (optional)",
    required: false,
    value: ""
  },
  {
    id: 2,
    className: "looking_change",
    inputType: "select",
    userField: "looking_change",
    options: [
      { id: 0, value: "Yes" },
      { id: 1, value: "No" }
    ],
    title: `Are you looking to make a career change?`,
    required: true
  }
]

const mapLookingChangeValue = (inputValue) => {
  if (inputValue === "Yes" || inputValue === "No") return inputValue
  if (inputValue === 1 || inputValue === "1") return "Yes"
  if (inputValue === 0 || inputValue === "0") return "No"
  return ""
}

const PersonalInfoInputs = (props) => {
  const is_spouse = props.user.is_spouse
  const containerClass = !is_spouse ? "profileProfessionalContainer" : "profileTwoProfessionalContainer"
  const inputDataWithValues = inputs.map((input) => {
    const applicationValue = Object.byString(
      props.application.application,
      input.userField
    )
    const userValue = Object.byString(props.user, input.userField)
    const inputValue =
      applicationValue !== undefined && applicationValue !== null && applicationValue !== ""
        ? applicationValue
        : userValue

    if (input.inputType === "select") {
      return {
        ...input,
        value: mapLookingChangeValue(inputValue)
      }
    }

    return {
      ...input,
      value: inputValue || ""
    }
  })

  return (
    <InputGroup
      {...props}
      containerClass={containerClass}
      inputData={inputDataWithValues}
      renderComponent={({ inputComponent, inputData, checkSubmittability }) =>
        props.renderComponent({
          ...props,
          inputData,
          inputComponent,
          checkSubmittability
        })
      }
    />
  )
}

const mapStateToProps = (state) => ({
  application: state.application,
  user: state.user.user
})

export default connect(mapStateToProps)(
  withStyles(styleSheet)(PersonalInfoInputs)
)
